export class SaveSearchService {
	constructor($mdDialog, SearchService, SearchesService) {
		'ngInject';
		this.$mdDialog = $mdDialog;
		this.searchService = SearchService;
		this.searchesService = SearchesService;
		this.model = {};
	}
	openSaveSearch(model) {
		this.model.searchParams = model;
		this.$mdDialog
			.show({
				templateUrl: 'saved-search-add-name.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl'
			})
			.finally(() => {
				this.closeSaveSearch();
			});
	}
	saveSearch() {
		// let url = window.location.href;
		// let urlArr = url.split('/');
		// let tmp = [];
		// for (let i = 0; i < urlArr.length; i++) {
		// 	if (!/darab=\d+$/.test(urlArr[i]) && !/oldal=\d+$/.test(urlArr[i])) {
		// 		tmp.push(urlArr[i]);
		// 	}
		// }
		// this.model.url = tmp.join('/');

		// this.model.searchParams = this.queryStringToJSON(this.searchService.transformFormData(this.allFormData));
		// delete this.model.searchParams.page;
		// delete this.model.searchParams.pageSize;

		this.model.searchParams = JSON.stringify(this.model.searchParams);
		this.model.url = window.location.href;
		this.searchesService
			.checkExistance({ url: this.model.url })
			.then(() => {
				// a menteni kívánt keresés létezik
				this.notifications = {
					message: 'A menteni kívánt keresés már létezik.'
				};
			})
			.catch(() => {
				// nem létező keresés, mentjük
				this.searchesService
					.saveSearch(this.model)
					.then(() => {
						// mentve
						this.notifications = {
							message: 'Sikeres mentés.'
						};
						this.alreadyExistingSearchName = this.model.name;
						window.ipEventBus.publish('search-saved', this.alreadyExistingSearchName);
					})
					.catch(() => {
						this.notifications = {
							message: 'Sikertelen mentés.'
						};
					});
			});
	}

	queryStringToJSON(url) {
		if (url.length >= 2) {
			if (url.startsWith('?&')) {
				url = url.substring(1);
			}
		} else {
			return '{}';
		}
		let pairs = url.slice(1).split('&');

		let result = {};
		for (let i = 0; i < pairs.length; i++) {
			let pair = pairs[i];
			pair = pair.split('=');
			result[pair[0]] = decodeURIComponent(pair[1] || '');
		}
		return result;
	}
	closeSaveSearch(type) {
		this.model.name = '';
		this.notifications = {};
		this.$mdDialog.hide();
	}
}
